export default "__VITE_ASSET__DtH$GmWp__"